import {Banner} from './banner.js';
export class BannerMyadsphonewebsitebanner extends Banner {
	constructor(component_key) {
		super(component_key);
		this.$floating_btn = jQuery('.js-molecule_myadsphonefloatingbutton');
		jQuery(`.js-${component_key}`).on('click', this.click_listener);
	}

	show() {
		super.show();
		this.$floating_btn.addClass('hidden');
	}

	close() {
		super.close();
		this.$floating_btn.css('display', 'grid');
	}
	click_listener(e) {
		if (jQuery(e.target).closest('.js-banner_myadsphonewebsitebanner_close').length) {
			return;
		}
		yalwa.v.component_instances?.dialog_myadsphonewebsitedialog?.show();
	}
}
